import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { reportError } from "@/lib/error-reporting";
import { WAITLIST_POSITION_OFFSET } from "@/lib/waitlist-config";

export const useWaitlistCount = () => {
  return useQuery({
    queryKey: ["waitlist-count"],
    queryFn: async () => {
      // Use secure RPC function instead of direct table query
      const { data, error } = await supabase.rpc('get_waitlist_count');

      if (error) {
        reportError(error, 'waitlist', { action: 'fetch-count' });
        return WAITLIST_POSITION_OFFSET; // Fallback to offset if error
      }

      return (data || 0) + WAITLIST_POSITION_OFFSET;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    refetchOnWindowFocus: false,
  });
};

export const formatWaitlistCount = (count: number): string => {
  // Format as "900+" style
  const rounded = Math.floor(count / 100) * 100;
  return `${rounded.toLocaleString()}+`;
};
